"use client";

import posthog from "posthog-js";
import { BUSINESS } from "@/lib/constants";

interface SpaPartyButtonProps {
  className?: string;
  children: React.ReactNode;
}

export function SpaPartyButton({ className, children }: SpaPartyButtonProps) {
  return (
    <a
      href={BUSINESS.spaPartyFormUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={() => posthog.capture("spa_party_inquiry_clicked")}
    >
      {children}
    </a>
  );
}
